module.exports = __webpack_public_path__ + "static/the-death-of-truth-3e0a5f219815f836da713937d417e4cb.jpg";